<template>
  <ComplianceReviewDecisionFooter
    :worker-name="workerName"
    :incomplete-count="incompleteCount"
    :loading="loading"
    :submitting="isSubmitting"
    :error-message="mutationErrorMessage"
    @submit="onSubmit"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useMutation } from '@vue/apollo-composable'
import { graphql } from '@/gql'
import { WorkerReviewDecision } from '@/gql/graphql'
import ComplianceReviewDecisionFooter from '@/components/compliances/ComplianceReviewModal/ComplianceReviewDecisionFooter.vue'
import type { ReviewDecision } from '@/components/compliances/ComplianceReviewModal/ComplianceReviewDecisionForm.vue'

const props = defineProps<{
  workerId: string
  workerName?: string
  incompleteCount?: number
  loading?: boolean
}>()
const emit = defineEmits<{ success: [] }>()

const SubmitComplianceMutation = graphql(`
  mutation SubmitCompliance($input: SubmitComplianceInput!) {
    submitCompliance(input: $input) {
      name
      completed
    }
  }
`)

const {
  mutate: submitCompliance,
  loading: isSubmitting,
  error: mutationError,
} = useMutation(SubmitComplianceMutation, {
  clientId: 'publicApi',
  refetchQueries: ['ComplianceTrustedContactsTable', 'ComplianceReviewModal'],
  throws: 'never',
})

const mutationErrorMessage = computed(() => mutationError.value?.graphQLErrors?.[0]?.message ?? '')

async function onSubmit({ decision, note }: { decision: ReviewDecision; note: string | null }) {
  const result = await submitCompliance({
    input: {
      reviewWorker: {
        workerId: props.workerId,
        decision: decision as WorkerReviewDecision,
        workerMessage: note,
      },
    },
  })

  if (result) emit('success')
}
</script>
